import React, { useState } from 'react';
import DonateModal from './DonateModal';

// Changed "text" to "label" to match our Services component call
export default function DonateBtn({ className, label }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button 
        onClick={() => setIsModalOpen(true)}
        className={`bg-gh-orange text-white px-6 py-2 rounded-md font-bold hover:bg-orange-600 transition shadow-md active:scale-95 uppercase tracking-wider ${className}`}
      >
        {/* If no label is provided, it defaults to "DONATE" */}
        {label || "DONATE"}
      </button>

      <DonateModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
}